$('#footer-pages h6').on('click', function () {
  $('#footer-pages').toggleClass('expand');
});

$('.return-top').on('click', function () {
  $('html, body').animate({
    scrollTop: 0,
  }, 'fast');
});
